import { NominationRole } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardNominationRole: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<NominationRole> = (fetchContext, awardId, nominationId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/role`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationRole>(fetchContext.errorStore, response, 'get award nomination role'));
